// LIST
export const FETCH_LOCATIONS = "app/Location/FETCH_LOCATIONS";
export const FETCH_LOCATIONS_SUCCESS = "app/Location/FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "app/Location/FETCH_LOCATIONS_FAILURE";

// SEARCH
export const SEARCH_LOCATION = "app/Location/SEARCH_LOCATION";
export const SEARCH_LOCATION_SUCCESS = "app/Location/SEARCH_LOCATION_SUCCESS";
export const SEARCH_LOCATION_FAILURE = "app/Location/SEARCH_LOCATION_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Location/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Location/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Location/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_LOCATION = "app/Location/ADD_LOCATION";
export const ADD_LOCATION_SUCCESS = "app/Location/ADD_LOCATION_SUCCESS";
export const ADD_LOCATION_FAILURE = "app/Location/ADD_LOCATION_FAILURE";

// EDIT
export const EDIT_LOCATION = "app/Location/EDIT_LOCATION";
export const EDIT_LOCATION_SUCCESS = "app/Location/EDIT_LOCATION_SUCCESS";
export const EDIT_LOCATION_FAILURE = "app/Location/EDIT_LOCATION_FAILURE";

// DELETE
export const DELETE_LOCATION = "app/Location/DELETE_LOCATION";
export const DELETE_LOCATION_SUCCESS = "app/Location/DELETE_LOCATION_SUCCESS";
export const DELETE_LOCATION_FAILURE = "app/Location/DELETE_LOCATION_FAILURE";

export const OPEN_WEBSITE_MODAL = "app/Location/OPEN_WEBSITE_MODAL";
export const CLOSE_WEBSITE_MODAL = "app/Location/CLOSE_WEBSITE_MODAL";

export const OPEN_ROOM_ADD_MODAL = "app/Location/OPEN_ROOM_ADD_MODAL";
export const CLOSE_ROOM_ADD_MODAL = "app/Location/CLOSE_ROOM_ADD_MODAL";

export const OPEN_VIEW_ROOMS_MODAL = "app/Location/OPEN_VIEW_ROOMS_MODAL";
export const CLOSE_VIEW_ROOMS_MODAL = "app/Location/CLOSE_VIEW_ROOMS_MODAL";

// ADD
export const ADD_ROOM = "app/Location/ADD_ROOM";
export const ADD_ROOM_SUCCESS = "app/Location/ADD_ROOM_SUCCESS";
export const ADD_ROOM_FAILURE = "app/Location/ADD_ROOM_FAILURE";

// LIST
export const FETCH_ROOMS = "app/Location/FETCH_ROOMS";
export const FETCH_ROOMS_SUCCESS = "app/Location/FETCH_ROOMS_SUCCESS";
export const FETCH_ROOMS_FAILURE = "app/Location/FETCH_ROOMS_FAILURE";

export const FETCH_ALL_LOCATION = "app/Location/FETCH_ALL_LOCATION";
export const FETCH_ALL_LOCATION_SUCCESS =
  "app/Location/FETCH_ALL_LOCATION_SUCCESS";
export const FETCH_ALL_LOCATION_FAILURE =
  "app/Location/FETCH_ALL_LOCATION_FAILURE";

// CARE ROOMS
export const FETCH_ALL_ROOMS = "app/Location/FETCH_ALL_ROOMS";
export const FETCH_ALL_ROOMS_SUCCESS = "app/Location/FETCH_ALL_ROOMS_SUCCESS";
export const FETCH_ALL_ROOMS_FAILURE = "app/Location/FETCH_ALL_ROOMS_FAILURE";

export const GET_CARE_ROOM_DATA = "app/Location/GET_CARE_ROOM_DATA";
export const GET_CARE_ROOM_DATA_SUCCESS =
  "app/Location/GET_CARE_ROOM_DATA_SUCCESS";
export const GET_CARE_ROOM_DATA_FAILURE =
  "app/Location/GET_CARE_ROOM_DATA_FAILURE";

export const DELETE_CARE_ROOM = "app/Location/DELETE_CARE_ROOM";
export const DELETE_CARE_ROOM_SUCCESS = "app/Location/DELETE_CARE_ROOM_SUCCESS";
export const DELETE_CARE_ROOM_FAILURE = "app/Location/DELETE_CARE_ROOM_FAILURE";

export const EDIT_CARE_ROOM = "app/Location/EDIT_CARE_ROOM";
export const EDIT_CARE_ROOM_SUCCESS = "app/Location/EDIT_CARE_ROOM_SUCCESS";
export const EDIT_CARE_ROOM_FAILURE = "app/Location/EDIT_CARE_ROOM_FAILURE";

export const OPEN_INVITE_MODAL = "app/Location/OPEN_INVITE_MODAL";
export const CLOSE_INVITE_MODAL = "app/Location/CLOSE_INVITE_MODAL";

export const INVITE_STAFF = "app/Location/INVITE_STAFF";
export const INVITE_STAFF_SUCCESS = "app/Location/INVITE_STAFF_SUCCESS";
export const INVITE_STAFF_FAILURE = "app/Location/INVITE_STAFF_FAILURE";

export const PROFILE_STEP_EDIT = "app/Location/PROFILE_STEP_EDIT";
export const PROFILE_STEP_EDIT_SUCCESS =
  "app/Location/PROFILE_STEP_EDIT_SUCCESS";
export const PROFILE_STEP_EDIT_FAILURE =
  "app/Location/PROFILE_STEP_EDIT_FAILURE";

export const TOGGLE_INVITE_REV = "app/Location/TOGGLE_INVITE_REV";

export const INVITE_REVIEW = "app/Location/INVITE_REVIEW";
export const INVITE_REVIEW_SUCCESS = "app/Location/INVITE_REVIEW_SUCCESS";
export const INVITE_REVIEW_FAILURE = "app/Location/INVITE_REVIEW_FAILURE";

export const GENERATE_CARD = "app/Location/GENERATE_CARD";
export const GENERATE_CARD_SUCCESS = "app/Location/GENERATE_CARD_SUCCESS";
export const GENERATE_CARD_FAILURE = "app/Location/GENERATE_CARD_FAILURE";
export const SET_CARD_LIST = "app/Location/SET_CARD_LIST";

export const SET_ACTIVE_LOCATION = "app/Location/SET_ACTIVE_LOCATION";
export const SET_ACTIVE_SURVEY = "app/Location/SET_ACTIVE_SURVEY";
export const SET_USER_LOCATIONS = "app/Location/SET_USER_LOCATIONS";
export const SET_ACTIVE_PATH = "app/Location/SET_ACTIVE_PATH";
export const SET_USER_PATH = "app/Location/SET_USER_PATH";

// LIST
export const FETCH_INVITEES = "app/Location/FETCH_INVITEES";
export const FETCH_INVITEES_SUCCESS = "app/Location/FETCH_INVITEES_SUCCESS";
export const FETCH_INVITEES_FAILURE = "app/Location/FETCH_INVITEES_FAILURE";

export const EXPORT_REVIEWS = "app/Location/EXPORT_REVIEWS";
export const EXPORT_REVIEWS_SUCCESS = "app/Location/EXPORT_REVIEWS_SUCCESS";
export const EXPORT_REVIEWS_FAILURE = "app/Location/EXPORT_REVIEWS_FAILURE";

export const TOGGLE_TEAM_MODAL = "app/Location/TOGGLE_TEAM_MODAL";

export const DELETE_TEAM = "app/Location/DELETE_TEAM";
export const DELETE_TEAM_SUCCESS = "app/Location/DELETE_TEAM_SUCCESS";
export const DELETE_TEAM_FAILURE = "app/Location/DELETE_TEAM_FAILURE";

export const TOGGLE_SORT_MODAL = "app/Location/TOGGLE_SORT_MODAL";

export const UPDATE_SEQ = "app/Location/UPDATE_SEQ";
export const UPDATE_SEQ_SUCCESS = "app/Location/UPDATE_SEQ_SUCCESS";
export const UPDATE_SEQ_FAILURE = "app/Location/UPDATE_SEQ_FAILURE";

export const GET_FEES = "app/Location/GET_FEES";
export const GET_FEES_SUCCESS = "app/Location/GET_FEES_SUCCESS";
export const GET_FEES_FAILURE = "app/Location/GET_FEES_FAILURE";

export const UPDATE_FEE = "app/Location/UPDATE_FEE";
export const UPDATE_FEE_SUCCESS = "app/Location/UPDATE_FEE_SUCCESS";
export const UPDATE_FEE_FAILURE = "app/Location/UPDATE_FEE_FAILURE";

export const GET_PROFILE = "app/Location/GET_PROFILE";
export const GET_PROFILE_SUCCESS = "app/Location/GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "app/Location/GET_PROFILE_FAILURE";

export const DELETE_FILE = "app/Location/DELETE_FILE";
export const DELETE_FILE_SUCCESS = "app/Location/DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILURE = "app/Location/DELETE_FILE_FAILURE";

export const DELETE_VIDEO = "app/Location/DELETE_VIDEO";
export const DELETE_VIDEO_SUCCESS = "app/Location/DELETE_VIDEO_SUCCESS";
export const DELETE_VIDEO_FAILURE = "app/Location/DELETE_VIDEO_FAILURE";

export const GET_BACK_VIEW = "app/Location/GET_BACK_VIEW";
export const GET_BACK_VIEW_SUCCESS = "app/Location/GET_BACK_VIEW_SUCCESS";
export const GET_BACK_VIEW_FAILURE = "app/Location/GET_BACK_VIEW_FAILURE";

export const EDIT_BASIC = "app/Location/EDIT_BASIC";
export const EDIT_BASIC_SUCCESS = "app/Location/EDIT_BASIC_SUCCESS";
export const EDIT_BASIC_FAILURE = "app/Location/EDIT_BASIC_FAILURE";
